module.exports = __webpack_public_path__ + "static/media/home_banner_openclaw.45e5a833.png";